import React, { useState, useEffect } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CloseIcon from "@mui/icons-material/Close";
import RejectIcon from "../../MerchantLoanRequests/icons/reject.svg";

const CorrectionInstructionsModal = ({
  onClose,
  onSubmit,
  title = "Write correction instructions.",
  message = "Are you sure you want to reject this bank inclusion request? Please write correction instructions in case this request needs to be raised again.",
  placeholder = "Correction Instructions",
  submitButtonText = "Reject",
  submitButtonIcon = CloseIcon,
  submitButtonClass = "btn--reject",
  minHeight = 120,
  maxLength = 1000,
  showCharacterCount = false,
  required = true,
}) => {
  const [instructions, setInstructions] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      e.stopPropagation();
    };

    window.addEventListener("keydown", handleKeyDown, true);
    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, []);

  const handleSubmit = async () => {
    if (required && !instructions.trim()) return;

    setSubmitting(true);
    try {
      await onSubmit(instructions);
    } finally {
      setSubmitting(false);
    }
  };

  const handleTextChange = (e) => {
    const value = e.target.value;
    if (maxLength && value.length <= maxLength) {
      setInstructions(value);
    } else if (!maxLength) {
      setInstructions(value);
    }
  };

  const isSubmitDisabled = (required && !instructions.trim()) || submitting;

  return (
    <div className="correction-modal-overlay">
      <div className="correction-modal">
        <div className="correction-modal-header">
          <div className="correction-modal-header-left">
            <button
              className="correction-modal-back"
              onClick={onClose}
              disabled={submitting}
            >
              <ArrowBackIosIcon fontSize="small" />
            </button>
            <h2 className="correction-modal-title">{title}</h2>
          </div>
          <button
            className="correction-modal-close"
            onClick={onClose}
            disabled={submitting}
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>

        <div className="correction-modal-content">
          <p className="correction-modal-message">{message}</p>

          <div className="correction-textarea-container">
            <textarea
              className="correction-textarea"
              placeholder={placeholder}
              value={instructions}
              onChange={handleTextChange}
              disabled={submitting}
              style={{ minHeight: `${minHeight}px` }}
              maxLength={maxLength || undefined}
            />
            {showCharacterCount && maxLength && (
              <div className="character-count">
                {instructions.length}/{maxLength}
              </div>
            )}
          </div>
        </div>

        <div className="correction-modal-footer">
          <button
            className={`btn ${submitButtonClass}`}
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            <img src={RejectIcon} alt="Reject" className="btn--icon" />
            {submitting ? "Processing..." : submitButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CorrectionInstructionsModal;
